import { GenericAbortSignal } from 'axios';
import { AutoCompleteSuggestions } from 'components/MprcAutoComplete';
import { ChannelAutoCompleteDataModel } from 'components/MprcAutoComplete/AutoCompleteDataModel';
import { isCanceledError, useCoreApi } from 'providers/CoreApiProvider';
import React from 'react';
import { BaseChannelAutoComplete, ChannelAutoCompleteProps, ChannelAutoCompleteQueryParams } from "views/knowledge/channels/components/BaseChannelAutoComplete";

////////////////////////////////////////////////////////////////////////////

interface IProps extends ChannelAutoCompleteProps {
    freeSelection?: boolean;
    onlyAutoRegister?: boolean;
}

/**
 * Auto complete de canais
 * @param props
 */
export const ChannelAutoComplete: React.FC<IProps> = (props) => {

    const api = useCoreApi();
    const { selectedItems, freeSelection = false, onlyAutoRegister = false, onChange, onError } = props;

    ///
    const getSuggestions = (p: ChannelAutoCompleteQueryParams, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<ChannelAutoCompleteDataModel>> => {
        return new Promise<AutoCompleteSuggestions<ChannelAutoCompleteDataModel>>((resolve) => {
            api.v1.knowledgeSuggestions.channels({
                searchText: p.searchText,
                pageNumber: p.pageNumber,
                pageSize: p.pageSize,
                freeSelection: freeSelection,
                onlyAutoRegister: onlyAutoRegister
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items as ChannelAutoCompleteDataModel[],
                        totalRows: result.data.totalRows
                    });
                })
                .catch(error => {
                    if (!isCanceledError(error)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(error);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <BaseChannelAutoComplete
            {...props}
            onChange={(itens) => onChange(itens as ChannelAutoCompleteDataModel[])}
            selectedItems={selectedItems}
            onGetSuggestions={getSuggestions}
        />
    );
};
